function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { SEC_PER_WEEK } from 'modules/MobileReports/constants';
import StatsCalculations from '../../../libs/StatsCalculations';
const getWeek = (timestamp, startDateTimestamp)=>Math.floor((timestamp - startDateTimestamp) / SEC_PER_WEEK);
const addWeeks = (timestamp, weeks = 1)=>timestamp + weeks * SEC_PER_WEEK;
const translateMomentDate = (momentDate, boundary = 'start')=>+momentDate.utc().locale('en--account')[`${boundary}Of`]('day').unix();
const createGroupedByWeek = (minTimestamp, maxTimestamp)=>{
    const groupedByWeek = new Map();
    const diffMs = maxTimestamp - minTimestamp;
    const weeksCount = Math.floor(diffMs / SEC_PER_WEEK);
    for(let i = 0; i <= weeksCount; i++){
        const startDayTimestamp = addWeeks(minTimestamp, i);
        groupedByWeek.set(i, {
            readingsWithRelatedData: [],
            timeSeriesResources: [],
            startDayTimestamp
        });
    }
    return groupedByWeek;
};
export const useWeeksData = (startDate, endDate, readings, relatedData, timeSeriesResources, standards, customRanges)=>{
    const startDateTimestamp = translateMomentDate(startDate);
    const endDateTimestamp = translateMomentDate(endDate, 'end');
    const groupedByWeek = createGroupedByWeek(startDateTimestamp, endDateTimestamp);
    timeSeriesResources.forEach((tsr)=>{
        const w = getWeek(tsr.timestamp, startDateTimestamp);
        if (!groupedByWeek.has(w)) return;
        groupedByWeek.get(w).timeSeriesResources.push(tsr);
    });
    readings.forEach((reading)=>{
        const w = getWeek(reading.timestamp, startDateTimestamp);
        if (!groupedByWeek.has(w)) return;
        const found = relatedData === null || relatedData === void 0 ? void 0 : relatedData.find((item)=>item.readingId === reading.externalId);
        if (found) reading.relatedData = found;
        groupedByWeek.get(w).readingsWithRelatedData.push(reading);
    });
    groupedByWeek.forEach((data)=>{
        const statsCalculations = new StatsCalculations(data.readingsWithRelatedData, standards, customRanges, 'value', 'timestamp');
        const averageData = statsCalculations.group('HOURS_RANGE', 'MEAN').map((item)=>_object_spread_props(_object_spread({}, item), {
                isAverage: true
            }));
        data.statsData = {
            readings: statsCalculations.group('HOURS_RANGE', 'NONE'),
            averageData
        };
    });
    return new Map([
        ...groupedByWeek.entries()
    ].reverse());
};
